module.exports = __webpack_public_path__ + "static_official_spa/img/business_ cooperation.300e002c.png";